import stl from "./ShapeCheckBox.module.css";

const ShapeCheckBox = ({ name, count, image, disabled, onChange, checked }) => {
  return (
    <>
      <div
        className={`${stl.container} ${disabled ? stl.disabled : ""}`}
        data-disabled={disabled}
      >
        <input type="checkbox" onChange={onChange} checked={checked} />
        <div className={stl.subContainer}>
          <div className={stl.imageContainer}>
            <img src={image} alt="car shape" />
          </div>
          <div className={stl.nameContainer}>
            <span>{name}</span> <span className={stl.count}>({count})</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShapeCheckBox;
